import React from 'react';
import { useEffect, useState } from "react";
import GreetingForm from "./components/GreetingForm";
import GreetingList from "./components/GreetingList";



function App() {
  const [greetings, setGreetings] = useState([]);

  const fetchGreetings = async () => {
    const response = await fetch("/api/greetings");
    const data = await response.json();
    setGreetings(data);
  };

  useEffect(() => {
    fetchGreetings();
  }, []);

  const handleNewGreeting = (newGreeting) => {
    setGreetings((prev) => [newGreeting, ...prev].slice(0, 5));
  };

  return (
    <div className="container">
      <h1>Tervetuloa Telaketjuun!</h1>
      <GreetingForm onNewGreeting={handleNewGreeting} />
      <h2>Viimeisimmät terkut:</h2>
      <GreetingList greetings={greetings} />
    </div>
  );
}

export default App;
